import React, { ReactElement } from 'react';
import { IColumn } from './types';
import useTableContext from './hooks/useTableContext';

interface IProps {
  columns: IColumn[];
}

const TableHeaders = ({ columns }: IProps): ReactElement => {
  const { columnWidths } = useTableContext();

  const headerWidths = columns.reduce<number[]>((output, column, index) => {
    // Find the width of the provided headers. Missing headers give their width to the previous column.
    if (column.Header) {
      output[output.length] = columnWidths[index];
    } else {
      output[output.length - 1] += columnWidths[index];
    }
    // Add 40px to the first column to account for the drag handle. When this is moved into the label, this quirk will be removed.
    if (index === 0) {
      output[index] += 25;
    }
    if (index === columns.length - 1) {
      output[index] = columnWidths[index];
    }
    return output;
  }, []);

  return (
    <div className="flex">
      {columns.map(({ Header, key }, index) => {
        if (!Header) return null;
        return <Header key={key} columnWidth={headerWidths[index]} columnIndex={index} />;
      })}
    </div>
  );
};

export default TableHeaders;
